var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImplant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM6 3V6H3V8H6V11H8V8H11V6H8V3H6Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.00002C16 7.59074 15.9431 8.16818 15.8344 8.72714C15.8623 8.72756 15.8906 8.72778 15.9194 8.72778C17.0633 8.72779 18.1145 8.44929 18.6289 8.25925L18.6918 8.23606C19.1533 8.06626 19.191 8.08576 19.2668 8.12494L19.2844 8.1339C19.4442 8.21227 19.5847 8.31009 19.6977 8.45802C19.8074 8.60143 19.9366 8.85097 19.9828 9.3041C20.0581 10.0425 19.9067 11.2663 19.1479 13.2412H13.4844C12.8452 13.9052 12.1049 14.4713 11.2883 14.9146C11.4402 15.2691 11.5928 15.5979 11.7382 15.891L12.2213 19.683C12.2618 20.0007 12.4553 20.2799 12.7413 20.4333L15.4345 21.8782C15.7368 22.0404 16.1022 22.0406 16.4047 21.8788L19.1959 20.3855C19.4825 20.2322 19.6764 19.9527 19.717 19.6346L20.1957 15.8766C21.6688 12.7111 22.1236 10.5834 21.9725 9.10121C21.8934 8.32511 21.6468 7.71418 21.2865 7.24297C20.9298 6.77629 20.5065 6.50533 20.1651 6.33785C19.2617 5.89471 18.5224 6.16684 18.0161 6.35319L17.9499 6.37755C17.4952 6.54523 16.7542 6.71588 15.9959 6.7268C15.9986 6.81754 16 6.90862 16 7.00002ZM13.6785 15.2955L13.651 15.2416H18.2845L18.2515 15.3116L18.133 16.2418H13.7991L13.6785 15.2955ZM14.0539 18.2423L14.1336 18.8673L15.9194 19.868L17.7924 18.915L17.8782 18.2423H14.0539Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImplant);
export default __webpack_public_path__ + "static/media/add-implant.b6dd6fa6.svg";
export { ForwardRef as ReactComponent };